import "../components/diagram-slide/diagram-slide";
import "../components/image-slide/image-slide";
import "../components/video-slide/video-slide";
import "../components/literary-design-slide/literary-design-slide";
import "../components/ephesians-literary-design-slide/ephesians-literary-design-slide";
import "../components/macro-literary-design-slide/macro-literary-design-slide";
import "../components/main-point-slide/main-point-slide";
import "../components/multi-verse-slide/multi-verse-slide";
import "../components/paragraph-slide/paragraph-slide";
import "../components/question-slide/question-slide";
import "../components/resource-slide/resource-slide";
import "../components/single-verse-slide/single-verse-slide";
import "../components/table-slide/table-slide";
import "../components/title-slide/title-slide";
import "../components/thank-you-slide/thank-you-slide";
import "../components/verse-comparison-slide/verse-comparison-slide";
import "../components/word-definition-slide/word-definition-slide";
import "../components/scrollable-slide/scrollable-slide";
import "../components/zoomable-slide/zoomable-slide";
import "../components/slide/slide";
import "../components/slide-presentation/slide-presentation";
